import React from 'react';

import { Controller, Control } from 'react-hook-form';
import { MultiselectField } from 'components';

type Item<T> = {
  label: string;
  value: T;
};

type Props<T> = {
  control: Control<any>;
  errorMessage?: string[] | null;
  name: string;
  items: Item<T>[];
  isFullWidth?: boolean;
  placeholder?: string;
  label?: string;
  fixedLabel?: boolean;
  doTranslation?: boolean;
  disabled?: boolean;
  ariaLabel?: string;
  onValueChange?: any;
  isRequired?: boolean;
  testId?: string;
  returnValueOnly?: boolean;
  truncateSelectedItems?: boolean;
  dataCy?: string;
};

export function HookFormMultiSelectDropdown<T>({
  control,
  name,
  items,
  placeholder,
  isFullWidth,
  label,
  fixedLabel,
  ariaLabel,
  doTranslation,
  disabled,
  onValueChange,
  isRequired,
  testId,
  returnValueOnly = false,
  truncateSelectedItems,
}: Props<T>) {
  return (
    <Controller
      control={control}
      name={name}
      rules={{
        validate: value =>
          !isRequired || (Array.isArray(value) && value.length > 0),
      }}
      render={({ field: { onChange, value } }) => (
        <MultiselectField
          label={label}
          isSearchable
          placeholder={placeholder}
          value={
            returnValueOnly
              ? items.filter(item => (value ?? []).includes(item.value))
              : value
          }
          onChange={(e: Item<T>[]) => {
            const nextValue = returnValueOnly
              ? e.map(item => item.value)
              : e;

            onChange(nextValue);

            if (onValueChange) {
              onValueChange(nextValue);
            }
          }}
          items={items}
          isFullWidth={isFullWidth}
          ariaLabel={ariaLabel}
          fixedLabel={fixedLabel}
          doTranslation={doTranslation}
          disabled={disabled}
          isRequired={isRequired}
          testId={testId}
          truncateSelectedItems={truncateSelectedItems}
        />
      )}
    />
  );
}

export default HookFormMultiSelectDropdown;
